import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import jwt_decode from 'jwt-decode';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  currentUser = new BehaviorSubject(undefined);
  authToken = new BehaviorSubject(undefined);
  currentClient = new BehaviorSubject(undefined);
  currentLocation = new BehaviorSubject(undefined);
  currentLocationJson = new BehaviorSubject(undefined);
  toogleMenu = new BehaviorSubject(undefined);
  toogleMenu2 = new BehaviorSubject(undefined);


  constructor(private router: Router) { }

  async loginUser(tokenUser: any, url = "") {
    await sessionStorage.setItem('@WebRevoCotacao:tokenUser', JSON.stringify(tokenUser));
    var decode: any = jwt_decode(tokenUser);
    await this.authToken.next(tokenUser);
    await this.currentUser.next(decode);
    // if (!decode.modo_noturno) {
    //   delete decode.modo_noturno;
    // }
    this.router.navigate(['home']);
  }

  async saveUser(tokenUser: any) {
    await sessionStorage.setItem('@WebRevoCotacao:tokenUser', JSON.stringify(tokenUser));
    var decode: any = jwt_decode(tokenUser);
    await this.authToken.next(tokenUser);
    await this.currentUser.next(decode);
  }

  async logoutUser() {
    await sessionStorage.clear();
    await this.authToken.next(undefined);
    await this.currentUser.next(undefined);
    await this.toogleMenu.next(undefined);
    await this.toogleMenu2.next(undefined);

    this.router.navigate(['login']);
  }


  async authCheck(tokenUser: any) {
    await sessionStorage.setItem('@WebRevoCotacao:tokenUser', JSON.stringify(tokenUser));
    var decode: any = jwt_decode(tokenUser);
    await this.authToken.next(tokenUser);
    await this.currentUser.next(decode);
  }

  async setLocation(location: any) {
    await localStorage.setItem('@WebRevoCotacao:location', location);
    await this.currentLocation.next(location);
  }


  async setLocationJson(location: any) {
    await localStorage.setItem('@WebRevoCotacao:locationJson', JSON.stringify(location));
    await this.currentLocationJson.next(location);
  }

  async setAtualizarMenu(att: any) {
    await this.toogleMenu.next(att);
    await this.toogleMenu2.next(undefined);

  }

  async setAtualizarMenu2(att: any) {
    await this.toogleMenu2.next(att);
    await this.toogleMenu.next(undefined);

  }
}
